import React, { memo } from 'react';

const FooterCompanyProvider = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/nha-cung-cap'
            target='_blank'
            className='mb-0 pl-2'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterCompanyProvider);
